"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var ui_1 = require("@vidazoo/ui");
var utils_1 = require("@vidazoo/ui/lib/components/utils");
var ReportingActions = /** @class */ (function (_super) {
    tslib_1.__extends(ReportingActions, _super);
    function ReportingActions(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = { echoButtons: _this.shouldEchoButtons(window.innerWidth) };
        _this.onWindowResize = utils_1.debounce(_this.onWindowResize, 100).bind(_this);
        return _this;
    }
    ReportingActions.prototype.shouldEchoButtons = function (windowWidth) {
        var minWindowWidthToGroupActions = this.props.minWindowWidthToGroupActions;
        return minWindowWidthToGroupActions > 0
            ? windowWidth > minWindowWidthToGroupActions
            : true;
    };
    ReportingActions.prototype.componentDidMount = function () {
        if (this.props.minWindowWidthToGroupActions) {
            window.addEventListener("resize", this.onWindowResize, false);
        }
    };
    ReportingActions.prototype.componentWillUnmount = function () {
        if (this.props.minWindowWidthToGroupActions) {
            window.removeEventListener("resize", this.onWindowResize, false);
        }
    };
    ReportingActions.prototype.onWindowResize = function () {
        var _this = this;
        utils_1.raf(function () {
            var ww = window.innerWidth;
            _this.setState({
                echoButtons: _this.shouldEchoButtons(ww)
            });
        });
    };
    ReportingActions.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, onCopyLink = _a.onCopyLink, onDownloadCSV = _a.onDownloadCSV, onSaveScheduledReport = _a.onSaveScheduledReport, onPresetReport = _a.onPresetReport, onOfflineReport = _a.onOfflineReport, customAction = _a.customAction;
        var echoButtons = this.state.echoButtons;
        return (React.createElement(ui_1.ButtonsList, { label: "Reporting Actions", echo: echoButtons },
            React.createElement("div", { className: theme.buttons },
                onDownloadCSV ? React.createElement(ui_1.Button, { iconName: "icon-download", medium: true, flat: true, disabled: disabled, onClick: onDownloadCSV }, "Download CSV") : null,
                onCopyLink ? React.createElement(ui_1.Button, { iconName: "icon-link", medium: true, flat: true, onClick: onCopyLink }, "Copy Link") : null,
                onSaveScheduledReport ? React.createElement(ui_1.Button, { iconName: "icon-save", medium: true, flat: true, onClick: onSaveScheduledReport }, "Save as Scheduled Report") : null,
                onPresetReport ? React.createElement(ui_1.Button, { iconName: "icon-preset", medium: true, flat: true, onClick: onPresetReport }, "Preset Report") : null,
                onOfflineReport ? React.createElement(ui_1.Button, { iconName: "icon-offline", medium: true, flat: true, onClick: onOfflineReport }, "Offline Report") : null,
                customAction ? React.createElement(ui_1.Button, tslib_1.__assign({ medium: true, flat: true }, customAction), customAction.label) : null)));
    };
    ReportingActions.defaultProps = {
        minWindowWidthToGroupActions: 0
    };
    return ReportingActions;
}(React.Component));
exports.default = ReportingActions;
